export const AgentSkillSource = {
  UPLOAD: 'upload',
  URL: 'url',
  BUILTIN: 'builtin',
  INLINE: 'inline',
} as const;

export type AgentSkillSource =
  (typeof AgentSkillSource)[keyof typeof AgentSkillSource];

export const AgentSkillScope = {
  GLOBAL: 'global',
  PROJECT: 'project',
} as const;

export type AgentSkillScope =
  (typeof AgentSkillScope)[keyof typeof AgentSkillScope];

export interface AgentSkillManifest {
  name: string;
  description?: string;
  version?: string;
  allowedTools?: string[];
}

export interface AgentSkill {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  version: string | null;
  source: AgentSkillSource;
  sourceUrl: string | null;
  manifest: AgentSkillManifest | null;
  /** Only returned by the detail endpoint. */
  skillMd?: string;
  scope: AgentSkillScope;
  enabledByDefault: boolean;
  userId: string;
  projectId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface InstallAgentSkillDto {
  skillMd?: string;
  url?: string;
  slug?: string;
  enabledByDefault?: boolean;
}

export interface AgentSkillBinding {
  id: string;
  skillId: string;
  projectId: string | null;
  agentId: string | null;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
  skill?: AgentSkill;
}

export interface CreateSkillBindingDto {
  skillId: string;
  enabled?: boolean;
}
